import { scrollToFirstError } from 'platform/utilities/ui';
import { $ } from 'platform/forms-system/src/js/utilities/ui';

/**
 * Focuses the form-level error alert when a field error is present.
 *
 * @param {number} _index - Unused step index argument to maintain shared helper signature
 * @param {HTMLElement|Document} root - Root node to search for field-level errors
 * @returns {boolean} True when an error was found and focus/scroll behavior was triggered
 */
export const focusFirstError = (_index, root) => {
  const error = $('[error], .usa-input-error', root);
  if (error) {
    scrollToFirstError({ focusOnAlertRole: true });
    return true;
  }
  return false;
};

/**
 * Formats a numeric currency value for display.
 *
 * - Whole dollar amounts are displayed without cents (e.g. 1000 -> '$1,000')
 * - Amounts with cents are displayed with exactly 2 decimal places (e.g. 10.5 -> '$10.50')
 * - null or undefined values return a fallback string
 *
 * @param {number|null|undefined} amount - The numeric currency value to format
 * @returns {string|null} The formatted currency string (e.g. '$1,000' or '$10.50'),
 *   or null if amount is null or undefined. Use || to provide a fallback:
 *   `formatCurrency(item?.paymentAmount) || 'Amount not provided'`
 *
 * @example
 * formatCurrency(1000)      // '$1,000'
 * formatCurrency(10.5)      // '$10.50'
 * formatCurrency(1234567.89) // '$1,234,567.89'
 * formatCurrency(null)      // null
 * formatCurrency(undefined) // null
 */
export const formatCurrency = amount => {
  if (amount == null) return null;
  return `$${Number(amount).toLocaleString('en-US', {
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};
